<template>
  <section>
    <div class="form-content">

      <!-- <el-form-item label="领用人">
        <span class="cont" v-if="user.name">{{user.name+"/"+(user.telephone?user.telephone:user.mobile)}}</span>
        <el-button @click="addUsers()" size="mini" type="primary">添加领用人
        </el-button>
      </el-form-item> -->

      <el-form-item label="领用时间">
        <el-date-picker v-model="form.time" style="width:250px!important;" value-format="yyyy-MM-dd HH:mm:ss"
          size="mini" type="datetime" placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="物品明细">
        <section class="consumable-list">
          <div class="list-title">
            <div class="r">
              <el-button @click="AddConsumable()" type="primary" size="mini">添加物品</el-button>
            </div>
          </div>
          <div class="consumable-table">
            <el-table :data="form.consumableItems" border>
              <el-table-column prop="consumable.consumable.number" label="物品编号">
              </el-table-column>
              <el-table-column prop="consumable.consumable.name" width="260" label="明细名称">
              </el-table-column>
              <el-table-column prop="consumable.consumable.unit.name" align="center" label="计量单位">
              </el-table-column>
              <el-table-column prop="amount" align="center" label="数量">
              </el-table-column>
              <el-table-column prop="consumable.amount" align="center" label="总库存">
              </el-table-column>

              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="点击变更信息" placement="bottom">
                    <i @click="ConsumableChange(scope.row, scope.$index)"
                      class="iconfont icon-xiugai meeting-btn-icon  mbi-edit"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="点击删除" placement="bottom">
                    <i @click="ConsumableDelete(scope.$index)"
                      class="iconfont icon-close meeting-btn-icon mbi-remove"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </section>
      </el-form-item>
      <el-form-item label="用途及原因">
        <el-input type="textarea" placeholder="简要填写用途及原因" :autosize="{ minRows: 3, maxRows: 6}" size="small"
          v-model="form.remark"></el-input>
      </el-form-item>
    </div>
    <!-- 添加物品 -->
    <div class="pop-room" v-if="addStatus">
      <a href="javascript:;" @click="addStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="mform" label-width="120px" class="form">
            <el-form-item label="物品编号" v-if="mform.consumable">
              <el-input :disabled="true" size="small" v-model="mform.consumable.consumable.number"></el-input>
            </el-form-item>
            <el-form-item label="*明细名称">
              <el-select size="small" style="width:100%" filterable v-model="mform.consumableId" @change="handleSelect"
                placeholder="支持搜索">
                <!-- <el-option v-for="item in consumableList" :key="item.id"
                  :label="item.name" :value="item.id">
                </el-option> -->
                <el-option v-for="item in consumableList" :key="item.id"
                  :label="item.name+' ('+item.dl.name+')'+(item.spec?' 【'+item.spec+'】':'')" :value="item.id">
                </el-option>

              </el-select>
            </el-form-item>

            <el-form-item label="*数量">
              <el-input size="small" type="number" v-model="mform.amount"></el-input>
            </el-form-item>

            <el-form-item label="实时库存" v-if="mform.consumable">
              <el-input size="small" :disabled="true" type="number" v-model="mform.consumable.amount"></el-input>
            </el-form-item>
            <el-form-item label="计量单位" v-if="mform.consumable">
              <el-select @change="forceUpdate" :disabled="true" size="small" filterable
                v-model="mform.consumable.consumable.unit.id" placeholder="请选择计量单位">
                <el-option v-for="item in unitList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="">
              <el-button @click="AddBtnClick()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>
  </section>

</template>
<script>
  import {
    mapState
  } from "vuex";

  export default {
    computed: {
      ...mapState({
        // contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    props: ['formByFather', 'userData', 'isBack'],
    data() {
      return {
        form: {},

        user: {},
        unitList: [],
        consumableList: [],

        addType: 0,
        editIndex: '',
        mform: {
          consumable: '',
          consumableId: '',
          amount: '',
        },

        addStatus: false,

        // 选择项目列表
        projectList: [],
      }
    },
    created() {},
    mounted() {
      this.form = this.formByFather
      this.form.customerId = this.userData.id
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1

      this.getUnitList()
      this.getConsumableList()
    },
    methods: {

      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      // 选择物品后ajax查询物品详细
      handleSelect(consumableId) {
        ajax.post('/consumable/queryBy/id', {
          id: consumableId,
          depId: this.form.depId,
        }, (res) => {
          this.mform.consumable = res.vo
        })
      },
      // 编辑物品
      ConsumableChange(row, index) {
        this.addType = 1
        this.editIndex = index
        this.mform = row
        this.addStatus = true
      },
      // 从列表里删除当前物品
      ConsumableDelete(index) {
        // console.log(index)
        this.form.consumableItems.splice(index, 1)
      },
      // 显示添加物品弹窗
      AddConsumable() {
        this.mform = {
          consumable: '',
          consumableId: '',
          amount: '',
        }
        this.addType = 0
        this.addStatus = true
      },
      // 添加物品到列表
      AddBtnClick() {
        if (!this.mform.consumableId || !this.mform.amount) {
          this.$message.error("请认真填写物品信息，带*为必填项")
          return
        }
        if (this.mform.amount > parseFloat(this.mform.consumable.amount)) {
          this.$message.error("\"" + this.mform.consumable.consumable.name + "\"库存数量不足，请联系相关部门")
          return
        }

        this.mform.unitName = this.getUnitName(this.mform.unitId)
        if (this.addType == 0) {
          this.form.consumableItems.push(this.mform)
        } else {
          this.form.consumableItems.splice(this.editIndex, 1, this.mform)
        }

        // 初始化
        this.mform = {
          consumable: '',
          consumableId: '',
          amount: '',
        }
        this.addStatus = false
      },
      // 获得计量单位名称
      getUnitName(unitId) {
        for (var i = 0; i < this.unitList.length; i++) {
          let _item = this.unitList[i]
          if (unitId == _item.id) {
            return _item.name
          }
        }
      },
      // 获取物品基础资料列表
      getConsumableList() {
        ajax.get('/consumable/stock/list', '', (res) => {
          this.loading = false
          this.consumableList = res.vo.array
        })
      },
      // 获取计量单位列表
      getUnitList() {
        ajax.get('/storage/unit/list', '', (res) => {
          this.unitList = res.vo.array
        })
      },
      // 返回form
      getFromData() {
        return this.form
      }
    },
    watch: {
      // contactSelectArr() {
      //   if (this.contactSelectArr.length < 1) {
      //     return
      //   }
      //   this.user = this.contactSelectArr[0]
      //   this.form.customerId = this.user.id
      // },
      formByFather() {
        this.form = this.formByFather
      },
      // 'form.consumables': {
      //   handler(newName, oldName) {
      //     let _total = 0
      //     for (let i = 0; i < this.form.consumables.length; i++) {
      //       let _item = this.form.consumables[i]
      //       _total += _item.amount * _item.price
      //     }
      //     this.form.total = _total.toFixed(2);
      //   },
      //   deep: true
      // }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/consumable/use.vue